var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"FireTraining"},[_c('NoData',{attrs:{"value":"敬请期待"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }